import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
  withXsrfConfiguration,
} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import {
  ApplicationConfig,
  EnvironmentProviders,
  linkedSignal,
  LOCALE_ID,
  Provider,
  provideZoneChangeDetection,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  BaseRouteReuseStrategy,
  provideRouter,
  Route,
  RouteReuseStrategy,
  TitleStrategy,
  withExperimentalAutoCleanupInjectors,
} from '@angular/router';
import { provideAiAgentModule } from '@softapps/ai-agent';
import { provideAiTableExtractorModule } from '@softapps/ai-table-extractor';
import {
  checklisteProviders,
  provideChecklistWidget,
} from '@softapps/allgemein/checkliste';
import {
  dashboardProviders,
  dashboardRoutes,
  provideKundeninfoWidget,
} from '@softapps/allgemein/dashboard';
import { withLogin } from '@softapps/allgemein/login';
import {
  moduleProviders,
  moduleRoutes,
  SOFTLINE_CONFIG_APP_OVERVIEW,
} from '@softapps/allgemein/modules';
import { passwordProviders } from '@softapps/allgemein/password';
import { pdfEditorProviders } from '@softapps/allgemein/pdf-editor';
import { pdfViewerProviders } from '@softapps/allgemein/pdf-viewer';
import { sendNotificationProviders } from '@softapps/allgemein/send-notification';
import {
  accountContextProviders,
  contextSettingsProviders,
  contextStorageProviders,
  notificationProviders,
  settingsProviders,
  userContextProviders,
  utilitiesProviders,
  vkforgContextProviders,
} from '@softapps/allgemein/utils';
import {
  ensureAgGridSetup,
  provideSoftApps,
  publicShellBadgeFor,
  SOFTLINE_CONFIG_CHATBOT_API,
  SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING,
  SOFTLINE_CONFIG_PUBLIC_SHELL_LOGO,
  SOFTLINE_ROUTES_APPS,
  SOFTLINE_ROUTES_EMBEDDED,
  SOFTLINE_ROUTES_PUBLIC,
  SOFTLINE_ROUTES_TERMINAL,
  withTerminalAutoLogin,
} from '@softapps/core';
import { masterdataEmbeddedRoutes } from '@softapps/core/masterdata';
import { fibuCoreProviders, kundeninfoLeisteProviders } from '@softapps/fibu/core';
import { freigabeProviders } from '@softapps/fibu/freigabe';
import { haftruecklassProviders } from '@softapps/fibu/haftruecklass';
import { offenePostenProviders } from '@softapps/fibu/offene-posten';
import { arbeitsberichtProviders } from '@softapps/gewerbe/arbeitsbericht';
import {
  arbeitsscheinProviders,
  arbeitsscheinWidgetProviders,
} from '@softapps/gewerbe/arbeitsschein';
// import { bestellungProviders } from '@softapps/gewerbe/bestellung';
import { provideClaimReportModule } from '@softapps/gewerbe/claim-report';
import { provideConstructionPartsModule } from '@softapps/gewerbe/construction-parts';
import { dokumentationProviders } from '@softapps/gewerbe/dokumentation';
import { provideWorkflowMonitorModule } from '@softapps/gewerbe/workflow';
import { artikelinfoProviders as artikelInfoProvidersHandel } from '@softapps/handel/artikelinfo';
import { gutscheinkartenProviders } from '@softapps/handel/gutscheinkarten';
// import { eslLinkProviders, provideEslLinkProviders } from '@softapps/handel/esl-link';
import { provideABCAnalysisProviders } from '@softapps/lager/abc-analysis';
import { lagerCoreProviders } from '@softapps/lager/core';
import { inventurProviders } from '@softapps/lager/inventur';
import {
  kommissionierungProviders,
  provideVorKommissionierung,
} from '@softapps/lager/kommissionierung';
import { lagerkorrekturProviders } from '@softapps/lager/lagerkorrektur';
import { lagerkorrekturArtikelProviders } from '@softapps/lager/lagerkorrektur-artikel';
import { lagerplatzUmlagerungProviders } from '@softapps/lager/lagerplatz-umlagerung';
import { lagerstandProviders } from '@softapps/lager/lagerstand';
import { palettenUmlagerungProviders } from '@softapps/lager/paletten-umlagerung';
import { providePalettenkorrektur } from '@softapps/lager/palettenkorrektur';
// import { provideProductRelocationModule, providePalletRelocationModule } from '@softapps/lager/product-relocation';
import { lieferantenstammProviders } from '@softapps/lieferantenstamm';
import { kommissionierungProviders as llrKommissionierungProviders } from '@softapps/llr/kommisionierung';
import { artikelvorratProviders } from '@softapps/mde/artikelvorrat';
import { bestellerfassungProviders } from '@softapps/mde/bestellerfassung';
import { bestellvorschlagProviders } from '@softapps/mde/bestellvorschlag';
import { einseitigeLagerbuchungProviders } from '@softapps/mde/einseitige-lagerbuchung';
import { provideMdcStockPostingModule } from '@softapps/mdc/stockposting';
import { etikettendruckProviders } from '@softapps/mde/etikettendruck';
import { provideMdeInventoryModule } from '@softapps/mde/inventory';
import { materiallieferscheinScanProviders } from '@softapps/mde/materiallieferschein-scan';
import { retourenProviders } from '@softapps/mde/retouren';
import { provideStorageLocation } from '@softapps/mde/storage-location';
import { warenverprobungProviders } from '@softapps/mde/warenverprobung';
// import { milchgeldProviders } from '@softapps/migel/core';
// import { abrechnungProviders } from '@softapps/migel/abrechung';
// import { anlieferungProviders, dashboardAnlieferungProviders, dashboardInfoProviders } from '@softapps/migel/anlieferung';
// import { anteileProviders } from '@softapps/migel/anteile';
// import { dashboardProviders as migelDashboardProviders } from '@softapps/migel/dashboard';
// import { infoProviders as migelInfoProviders, provideMigelInfo } from '@softapps/migel/info';
// import { kontoauszugProviders } from '@softapps/migel/kontoauszug';
// import { migelUtilsProviders, supplierContextProviders } from '@softapps/migel/utils';
import {
  arbeitsberichtStatistikProviders,
  arbeitsberichtStatistikWidgetProviders,
} from '@softapps/pms/arbeitsbericht-statistik';
import { pmsMeldungProviders } from '@softapps/pms/pmsmeldung';
import { provideRoster, withPmsRoster } from '@softapps/pms/roster';
import { statusabfrageProviders, statusabfrageRoutes } from '@softapps/pms/statusabfrage';
import {
  pmsStempelTerminalProviders,
  SOFTLINE_CONFIG_TERMINAL_PASSWORT,
} from '@softapps/pms/stempel-terminal';
import {
  provideStampCaptureService,
  provideStempelerfassungSearchAction,
  stempelerfassungProviders,
  stempelerfassungWidgetProviders,
} from '@softapps/pms/stempelerfassung';
import {
  provideSoftlineRosterSearchActions,
  provideSoftlineTimelineWidget,
  withSoftlineTicketRoster,
} from '@softapps/softline/roster';
// import { provideMilchmengenrechner } from '@softapps/produktion/milchmengenrechner';
import { provideGarageCore } from '@softapps/werkstatt/garage-core';
import { provideMachineCatalog } from '@softapps/werkstatt/machine-catalog';
import { provideGarageOrderModule } from '@softapps/werkstatt/order';
import { provideGarageReport } from '@softapps/werkstatt/report';
import { withGarageRoster } from '@softapps/werkstatt/roster';
import { provideToolModule, provideVehicleModule } from '@softapps/werkstatt/vehicle';

import { provideWwsAbcAnalysisModule } from '@softapps/wws/abc-analysis';
import { archivbelegUploadProviders } from '@softapps/wws/archivbeleg-upload';
import { artikelInfoProviders } from '@softapps/wws/artikel-info';
import { provideWwsArtikelstamm } from '@softapps/wws/artikelstamm';
import { basisartikelstandProviders } from '@softapps/wws/basisartikelstand';
import { provideBelegpruefung } from '@softapps/wws/belegpruefung';
// import { provideBelegpruefungWidget } from '@softapps/wws/belegpruefung';
import { provideWwsCore, withEmbedding } from '@softapps/wws/core';
import { provideDeliveryNoteProcessingModule } from '@softapps/wws/delivery-note-processing';
import { energietransportProviders } from '@softapps/wws/energietransport';
import { provideGesamtabfrage } from '@softapps/wws/gesamtabfrage';
import { kreditlimitProviders } from '@softapps/wws/kreditlimit';
import { kundenabfrageProviders } from '@softapps/wws/kundenabfrage';
import { kundenanlageProviders } from '@softapps/wws/kundenanlage';
import { lieferscheinProviders } from '@softapps/wws/lieferschein';
import { objektabfrageProviders } from '@softapps/wws/objektabfrage';
import { provideSalesModule } from '@softapps/wws/sales';
import { provideSalesStatisticsModule } from '@softapps/wws/sales-statistics';
import { withDeliveryNoteRoster } from '@softline/delivery-note-roster';
// import { provideSelfCheckoutModule, provideSelfCheckoutTouchModule } from '@softapps/wws/self-checkout';
import { subkundenProviders } from '@softapps/wws/subkunden';
import { provideUmsatzstatistikGlobals } from '@softapps/wws/umsatzstatistik';
import { provideDesignSystemCatalogModule } from '@softapps/design-system-catalog';
import { provideEslConfigModule } from '@softapps/handel/esl-config';
import { provideEslLinkProviders } from '@softapps/handel/esl-link';
import {
  provideEslLinkStorageProviders,
  provideEslSearchProviders,
} from '@softapps/handel/esl-link-storage';
import { providePurchaseStatisticsModule } from '@softapps/wws/purchase-statistics';
import { updatedArticleLabelPrintProviders } from '@softapps/wws/updated-article-label-print';
import {
  provideDarkTheme,
  provideDesignSystemCatalog,
  remoteConfigProviders,
  SOFTLINE_CONFIG_LANGUAGES,
  SOFTLINE_LANGUAGE_DE,
  SOFTLINE_LANGUAGE_EN,
  SoftlineTitleStrategy,
  TitleService,
} from '@softline/application';
import {
  authenticationProviders,
  SOFTLINE_CONFIG_AUTHENTICATION_FORWARD_ROUTE,
  SOFTLINE_CONFIG_JWT_EXPIRATION_TIME,
  SOFTLINE_CONFIG_JWT_REFRESH_TIME,
} from '@softline/auth';
import {
  provideNativeTooltipOverride,
  SOFTLINE_CONFIG_MESSAGE_BAR_DURATION,
} from '@softline/ui-core';
import { provideWarenuebernahmeModule } from '@softapps/wws/warenuebernahme';
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha-2';
import { customerConfig } from '../customer-config';
import { EslVariant } from '../customer-config.type';
import { environment } from '../environments/environment';
import { providePlatform } from '../platforms/platform';
import { publicRoutes, routeFactory, terminalRoutes } from './app.routes';
import { authenticationMode } from './authentication-mode';
import { selfCheckoutPublicRoutes } from '@softapps/wws/self-checkout';
// AG enterprise registration + license moved behind this lazy warm-up — keeps
// the ~1.3 MB gz AG stack out of the initial bundle.
void ensureAgGridSetup();
registerLocaleData(localeDe, 'de');

const appName = linkedSignal(() => customerConfig.name);

function eslProviders(variants: EslVariant[]): Array<Provider | EnvironmentProviders> {
  if (variants.includes('legacy') && variants.includes('link'))
    throw new Error(
      `[${customerConfig.id}] ESL 'legacy' and 'link' both own the /esl-link route`
    );
  const providers = variants.flatMap((variant) => {
    switch (variant) {
      case 'link':
        return provideEslLinkStorageProviders({ storageSelection: false });
      case 'storage':
        return provideEslLinkStorageProviders({ storageSelection: true });
      case 'legacy':
        return provideEslLinkProviders();
      case 'config':
        return provideEslConfigModule();
    }
  });
  return variants.includes('legacy')
    ? providers
    : [...providers, provideEslSearchProviders()];
}

export class SoftAppsRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldDestroyInjector(route: Route): boolean {
    return route?.data?.['destroyInjector'] === true ? true : false;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter([...selfCheckoutPublicRoutes], withExperimentalAutoCleanupInjectors()),
    {
      provide: RouteReuseStrategy,
      useClass: SoftAppsRouteReuseStrategy,
    },
    //provideAnimations(),

    provideHttpClient(
      withXhr(),
      withInterceptorsFromDi(),
      withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),

    // TODO: Routes
    {
      provide: SOFTLINE_ROUTES_APPS,
      useValue: routeFactory(customerConfig),
      multi: true,
    },
    {
      provide: SOFTLINE_ROUTES_TERMINAL,
      useValue: customerConfig?.terminalAutoLogin
        ? withTerminalAutoLogin(customerConfig.terminalAutoLogin, terminalRoutes)
        : terminalRoutes,
      multi: true,
    },
    { provide: SOFTLINE_ROUTES_PUBLIC, useValue: publicRoutes, multi: true },
    {
      provide: SOFTLINE_ROUTES_EMBEDDED,
      useValue: [
        ...moduleRoutes,
        ...statusabfrageRoutes,
        ...dashboardRoutes,
        ...masterdataEmbeddedRoutes,
      ],
      multi: true,
    },

    provideSoftApps(
      { connection: environment.connection },
      //withRegistration()
      ...(authenticationMode === 'jwt' ? [withLogin()] : [])
    ),
    ...(authenticationMode === 'bff' ? authenticationProviders() : []),
    providePlatform(environment),
    provideDarkTheme(),
    provideNativeTooltipOverride(),
    provideDesignSystemCatalog('/design-system'),
    {
      provide: TitleStrategy,
      useFactory: (title: Title, service: TitleService) =>
        new SoftlineTitleStrategy(appName(), title, service),
      deps: [Title, TitleService],
    },
    {
      provide: SOFTLINE_CONFIG_LANGUAGES,
      useValue: [SOFTLINE_LANGUAGE_DE, SOFTLINE_LANGUAGE_EN],
    },

    /**
     * Enables the virtual onscreen keyboard on all supported elements
     */
    // { provide: SOFTLINE_VIRTUAL_KEYBOARD, useValue: true },

    // TODO:
    /* provideSoftappsCore({
      userContext: true,
      contextStorage: true,
      pdfViewer: true,
      remoteConfig: true,
      vkforgContext: true,
      moduleOverview: {
        preserveProviderOrder: true,
      },
    })[0],
    */

    //** softapps/ai-table-extractor **//
    ...provideAiTableExtractorModule(),

    //** softapps/ai-agent **//
    ...(customerConfig.aiAgent === true
      ? provideAiAgentModule({ apiBaseUrl: customerConfig.aiAgentApi })
      : []),

    //** softapps/allgemein/utils **//
    ...contextSettingsProviders,
    ...accountContextProviders,
    ...settingsProviders,
    ...notificationProviders,
    ...remoteConfigProviders,
    ...vkforgContextProviders,
    ...userContextProviders,
    ...contextStorageProviders,

    //** softapps/allgemein **//
    ...checklisteProviders,
    ...dashboardProviders,
    ...moduleProviders,
    {
      provide: SOFTLINE_CONFIG_APP_OVERVIEW,
      useValue: {
        isGroupButtonActive: true,
        defaultView: 'notGrouped',
        isNonPermittedAppsButtonActive: environment.production ? false : true,
        disableNoPermissionApps: true,
      },
    },
    ...passwordProviders,
    ...pdfEditorProviders,
    ...pdfViewerProviders,
    ...sendNotificationProviders,
    ...provideWorkflowMonitorModule(),
    //...ssoProviders,
    ...utilitiesProviders,

    //* Dashboard Widgets *//

    ...stempelerfassungWidgetProviders,
    provideSoftlineTimelineWidget(),
    provideSoftlineRosterSearchActions(),
    ...arbeitsberichtStatistikWidgetProviders,
    ...arbeitsscheinWidgetProviders,
    ...kundeninfoLeisteProviders,
    provideKundeninfoWidget(),
    provideChecklistWidget(),
    //provideUmsatzstatistikModule({ widget: { period: 'today', branch: 'context' } }),

    //** softapps/fibu **//
    ...fibuCoreProviders,
    ...freigabeProviders,
    ...haftruecklassProviders,
    ...offenePostenProviders,

    //** softapps/gewerbe **//
    ...arbeitsberichtProviders, // needs definition
    ...arbeitsscheinProviders, // needs definition
    ...dokumentationProviders,
    provideConstructionPartsModule(),
    provideClaimReportModule(),
    //provideWorkflowMonitorModule(), // needs definition

    //** softapps/handel *//
    ...artikelInfoProvidersHandel,
    ...gutscheinkartenProviders,
    ...eslProviders(customerConfig.moduleConfig?.esl ?? ['link', 'config']),
    // ...eslLinkProviders,

    //** softapps/lager **//
    provideABCAnalysisProviders(),
    ...lagerCoreProviders,
    ...inventurProviders,
    provideVorKommissionierung(),
    ...kommissionierungProviders,
    ...lagerkorrekturProviders,
    ...lagerkorrekturArtikelProviders,
    ...lagerplatzUmlagerungProviders,
    ...lagerstandProviders,
    ...palettenUmlagerungProviders,
    providePalettenkorrektur(),

    //** softapps/llr **//
    ...llrKommissionierungProviders,

    //** softapps/mde **//
    ...artikelvorratProviders,
    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...einseitigeLagerbuchungProviders,
    provideMdcStockPostingModule(),
    ...etikettendruckProviders,
    provideMdeInventoryModule(),
    //...inventurProviders, OBSOLETE
    ...materiallieferscheinScanProviders,
    ...retourenProviders,
    provideStorageLocation(),
    ...warenverprobungProviders,

    ...energietransportProviders,

    //** softapps/pms **//
    ...arbeitsberichtStatistikProviders,
    ...pmsMeldungProviders, //TODO: FIX SORT AND FILTER
    provideRoster(
      withPmsRoster(),
      withSoftlineTicketRoster(),
      ...(customerConfig.moduleConfig?.garage === false ? [] : [withGarageRoster()]),
      ...(customerConfig.moduleConfig?.deliveryNoteRoster === false
        ? []
        : [withDeliveryNoteRoster()])
    ),
    ...statusabfrageProviders,
    ...pmsStempelTerminalProviders,
    ...stempelerfassungProviders,
    provideStampCaptureService(),
    provideStempelerfassungSearchAction(),
    provideWarenuebernahmeModule({
      reklamation: false,
      dierektannahme: true,
      lagerplatzauswahl: true,
      ekBarcode: false,
    }),

    //** softapps/produktion **//
    // ...absatzplanProviders,
    // ...produktionAuftragsPlanProviders, //TODO: broken
    // ...kundenKonditionslisteProviders,
    // provideMilchmengenrechner(),
    // ...produktionsauftragProviders,
    // ...pruefprotokollProviders,
    // ...rohstoffbereitstellungProviders,
    // ...rohstoffbilanzProviders,
    // ...rueckverfolgungProviders, //TODO: can't access property "feature", DashboardStore is undefined

    //** softapps/schmuck **//
    // ...produktkalkulationProviders,

    //** softapps/werkstatt **//
    //...auftragProviders,
    ...(customerConfig.moduleConfig?.garage === false
      ? []
      : [
          provideGarageCore(),
          provideGarageReport(),
          provideVehicleModule(),
          provideToolModule(),
          provideGarageOrderModule(),
          provideMachineCatalog(),
        ]),

    //** softapps/wws **//
    provideWwsAbcAnalysisModule(),
    ...(customerConfig.moduleConfig?.sales === false
      ? []
      : [provideSalesModule(customerConfig.moduleConfig?.sales)]),

    ...archivbelegUploadProviders,
    ...artikelInfoProviders,
    provideWwsArtikelstamm(),
    ...basisartikelstandProviders,
    provideBelegpruefung(),
    ...provideWwsCore(withEmbedding()), // FIELD OK providers & Embedded shell
    provideDeliveryNoteProcessingModule(),
    // ...gesamtabfrageProviders, // Belege MODULE
    provideGesamtabfrage(), // Belege MODULE
    ...kreditlimitProviders,
    ...kundenabfrageProviders,
    // the customer detail embeds the Umsatzstatistik widget; the module itself stays off
    ...provideUmsatzstatistikGlobals(),
    ...kundenanlageProviders,
    ...lieferantenstammProviders,
    ...lieferscheinProviders,
    // provideMinimumStockLevelUnderrunModule(),
    ...objektabfrageProviders,
    // providePurchaseOrderSuggestionModule(),
    // providePurchaseStatisticsModule(),
    // provideRegisterStatisticModule(),
    provideSalesStatisticsModule({ aiAgent: customerConfig.aiAgent === true }),
    providePurchaseStatisticsModule(),
    ...provideDesignSystemCatalogModule(),
    ...subkundenProviders,
    //...umsatzstatistikProviders,
    ...updatedArticleLabelPrintProviders,

    //** customers/dfh **//
    // ...bauprofiProviders,
    // ...bonusabfrageProviders,

    // ** customer/feichtinger **//
    // //...goldschmiedeProviders, //TODO: broken
    // ...wiegungProviders,

    {
      provide: SOFTLINE_CONFIG_TERMINAL_PASSWORT,
      useValue: 'Softline$12',
    },
    { provide: LOCALE_ID, useValue: 'de' },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptchaSiteKey } as RecaptchaSettings,
    },
    {
      provide: SOFTLINE_CONFIG_AUTHENTICATION_FORWARD_ROUTE,
      useValue: '/',
    },
    {
      provide: SOFTLINE_CONFIG_MESSAGE_BAR_DURATION,
      useValue: 2000,
    },
    {
      provide: SOFTLINE_CONFIG_JWT_EXPIRATION_TIME,
      useValue: 604_800, // 7 days
    },
    {
      provide: SOFTLINE_CONFIG_JWT_REFRESH_TIME,
      useValue: 172_800, // 2 days
    },

    { provide: SOFTLINE_CONFIG_PUBLIC_SHELL_BRANDING, useValue: true },

    // Default login badge, overridable by a customer config below.
    {
      provide: SOFTLINE_CONFIG_PUBLIC_SHELL_LOGO,
      useValue: { badge: publicShellBadgeFor(location.hostname) },
    },

    // Additional Customer Config Providers or overrides
    ...(customerConfig?.providers ?? []),
    ...(customerConfig?.chatbotApi
      ? [{ provide: SOFTLINE_CONFIG_CHATBOT_API, useValue: customerConfig.chatbotApi }]
      : []),
  ],
};
